import { Location } from '@angular/common';
import { Component, OnInit, ViewChild } from '@angular/core';
import { FormGroup, FormBuilder } from '@angular/forms';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { environment } from '@app-environments/environment';
import { AuthService } from '@app-services/auth-service/auth.service';
import { BoardsService } from '@app-services/boarrds/boards.service';
import { GAnalyticsService } from '@app-services/g-analytics/g-analytics.service';
import { LoginService } from '@app-services/login/login.service';
import { ScheduleService } from '@app-services/schedule/schedule.service';
import { SignupService } from '@app-services/signup/signup.service';
import { SubscriptionService } from '@app-services/subscription/subscription.service';
import { UserService } from '@app-services/user/user.service';
// import { IliteRegisterPopupComponent } from '@app-shared/components/ilite-register-popup/ilite-register-popup.component';
import { RegisterDialogComponent } from '@app-shared/components/register-dialog/register-dialog.component';
import { identity, isArray } from 'lodash-es';
import { NgxSpinnerService } from 'ngx-spinner';
import { ClassService } from 'src/app/core/services/class.service';
import { isUserAdmin, setLoggedInUserData } from 'src/app/helpers/functions';
import { startLearning } from '../target-exam/target-exam.component';
import { FirebaseAnalyticsService } from '@app-services/firebase-analytics/firebase-analytics.service';
import { MyactivityService } from 'src/app/core/services/myactivity.service';

export function cbseRegistration(urlData) {
  this.targetExamService.fetchTargetExamList().subscribe((data: any) => {
    var exams = data;
    let selectedExams = [];
    let index = exams.findIndex((ind) =>
      ind.name.replace(/[^a-z]/ig, '').toUpperCase() == urlData?.courses?.toUpperCase()
    );
    if (index > -1) {
      console.log(index)
      selectedExams.push(exams[index]);
      this.startLearning({ selectedExams, isILITE: false, grade: urlData.gradeObj, ILITEData: urlData, urlData: urlData })
    }
  });
}

interface CredentialRequestOptions {
  otp: OTPOptions;
  signal: any;
}

interface OTPOptions {
  transport: any[];
}

@Component({
  selector: 'app-verify-otp',
  templateUrl: './verify-otp.component.html',
  styleUrls: ['./verify-otp.component.css']
})
export class VerifyOtpComponent implements OnInit {
  config = {
    allowNumbersOnly: true,
    length: 4,
    isPasswordInput: false,
    disableAutoFocus: false,
    placeholder: '',
    inputStyles: {
      'width': '50px',
      'height': '50px'
    }
  };
  optErr = false
  resendOtpBtn = true
  otpValid = false
  counter
  otpForm: FormGroup;
  userData: any
  navExtra;
  exams: any;
  startLearning = startLearning;
  isILITE: boolean = false;
  queryParams: any = {};
  otpDetails: any;
  otpconsole: any = '0000';
  @ViewChild('ngOtpInput', { static: false}) ngOtpInput: any;
  regLiveclass: boolean;
  sendTrackAPIOnSignInOrSignUp: boolean = environment?.sendTrackAPIOnSignInOrSignUp;

  constructor(
    private targetExamService: BoardsService,
    private formBuilder: FormBuilder,
    public signupService: SignupService,
    private userService: UserService,
    private router: Router,
    private loginService: LoginService,
    private location: Location,
    private dialog: MatDialog,
    private scheduleService: ScheduleService,
    private authService: AuthService,
    private gaService: GAnalyticsService,
    private classService:ClassService,
    private SubscriptionService: SubscriptionService,
    private spinner: NgxSpinnerService, 
    private firebaseAnalyticsService: FirebaseAnalyticsService,
    private AchievementsService: MyactivityService,
  ) { this.navExtra = this.router.getCurrentNavigation()?.extras?.state;
    if(!this?.navExtra?.verify) {
        this.router.navigate(['/signin']);
        return;
      }
    let _params = {...(this.router.getCurrentNavigation()?.extras?.queryParams || {})};
    this.queryParams = {..._params};
  }

  ngOnInit(): void {
    let token = localStorage.getItem('token');
    let referralCode=JSON.parse(localStorage.getItem('reffCode'));
    this.userData = JSON.parse(localStorage.getItem('logData'));
    //? storing pagename 
    if(referralCode?.referralCode){
      localStorage.setItem('pgName','votp'); 
    }
    this.isILITE = this.navExtra?.isILITE;
    this.regLiveclass = this.navExtra?.regLiveclass;
    if (token && (!this.isILITE && !this.regLiveclass)) {
      if(this.userData.grade <3){
        this.router.navigate(['/dashboard/assessment']);
      }else{
        this.router.navigate(['/dashboard']);
      }
      return;
    }
    console.log(this.navExtra.passwordReset)
    this.otpForm = this.formBuilder.group({
      otp: [null],
    });
    console.log(this.userData);
    this.startCountdown(60);
    this.autoDetectOtpRequest();
  //   setTimeout(() => {
  //     this.autoDetectOtpRequest();
  //   }, 1000);
  }

  startCountdown(seconds: any) {
    this.counter = seconds;
    const interval = setInterval(() => {
      this.counter--;
      if (this.counter < 10) {
        if (this.counter == 0) {
          console.log(this.counter)
          this.resendOtpBtn = false;
          clearInterval(interval);
          document.getElementById('resend-otp')?.focus()
        }
        this.counter = '0' + this.counter
      }
    }, 1000); //for accurate reading, adjust this value to 980-996
  }

  async autoDetectOtpRequest() {
    this.otpconsole = '5885';
    this.otpconsole = Object.keys(window).includes('OTPCredential');
    if ('OTPCredential' in window) {
      this.otpconsole = 'OTPCredential If';
      window.addEventListener('DOMContentLoaded', e => {
        this.otpconsole = 'OTPCredential listner';
        const ac = new AbortController();
        let sign: CredentialRequestOptions = {
          otp: { transport: ['sms'] },
          signal: ac.signal
        };
        navigator.credentials.get(sign).then((otp: any) => {
          this.otpconsole = 'OTPCredential';
        }).catch(err => {
          console.log(err)
        });
      })
    } else {
      // alert('WebOTP not supported!.');
    }
  }

  onOtpChange(event: any) {
    // this.ngOtpInputRef.setValue(event);//yourvalue can be any string or number eg. 1234 or '1234'
    if (event.length === 4) {
      this.otpForm.get('otp')?.setValue(event);
      this.otpValid = true
    } else {
      this.otpValid = false
    }
  }

  verifyOTP() {
    console.log(this.userData)
    let page = "WEB_IL_SITE";
    if(this.navExtra?.urlData?.courses) {
      let x = this.navExtra?.urlData?.courses?.replace(/[^a-z]/i,'').toUpperCase(); 
      page = this.isILITE ? this.navExtra?.urlData?.origin?.toUpperCase() : x.indexOf("JEE") > -1 ? "JEE":  x.indexOf("NEET") > -1 ? "NEET": x.indexOf("CBSE") > -1 ? this.navExtra?.urlData?.page: "NA";
    }
    let payload = {
      countryCode: this.userData.dialCode, 
      phone: this.userData.number ? this.userData.number : this.userData.phone, 
      otp: this.otpForm.value.otp, 
      register: this.navExtra?.register, 
      page,
      "userActivityTrackingDataDto": 
        !this.sendTrackAPIOnSignInOrSignUp 
        ? undefined 
        : (this.navExtra?.urlData?.utm_id || this.navExtra?.urlData?.campaign_id)
          ? {
              "data": { 
                page: this.navExtra?.urlData?.page,
                utm_url: document.referrer + this.navExtra?.urlData?.page + '&' + 'utm_Id=' + this.navExtra?.urlData?.utm_id + '&' + 'utm_term=' + this.navExtra?.urlData?.utm_term+ '&' + 'utm_source=' + this.navExtra?.urlData?.utm_source+ '&' + 'utm_medium=' + this.navExtra?.urlData?.utm_medium+ '&' + 'utm_campaign=' + this.navExtra?.urlData?.utm_campaign+ '&' + 'utm_content=' +  this.navExtra?.urlData?.utm_content+ '&'  + 'utm_campaingn_id=' + this.navExtra?.urlData?.campaign_id,
                utm_id: this.navExtra?.urlData?.utm_id || this.navExtra?.urlData?.campaign_id,
                utm_term: this.navExtra?.urlData?.utm_term,
                utm_source: this.navExtra?.urlData?.utm_source,
                utm_medium: this.navExtra?.urlData?.utm_medium,
                utm_campaign: this.navExtra?.urlData?.utm_medium,
                utm_content: this.navExtra?.urlData?.utm_content,
                grade: this.navExtra?.urlData?.grade,
                liveclassId: this.navExtra?.urlData?.liveclassId,
                exam: this.navExtra?.urlData?.exam,
                action: this.navExtra?.urlData?.action
              },
              "landingPage": this.navExtra?.urlData?.page ? this.navExtra?.urlData?.page : page
            }
          : this.navExtra?.urlData?.page
            ? {
              "data": {...(this.navExtra?.urlData||{})},
              "landingPage": this.navExtra?.urlData?.page ? this.navExtra?.urlData?.page : page
            }
            : {
              "data": {...(this.navExtra?.urlData||{}), page},
              "landingPage": this.navExtra?.urlData?.page ? this.navExtra?.urlData?.page : page
            },
    };
    this.signupService.validateOtp(payload).subscribe((data) => {
      if (data?.accessToken)  {
        console.log(data)
        setLoggedInUserData(data, this.userService, this.authService);
        if(!this.sendTrackAPIOnSignInOrSignUp ) {
          if(this.navExtra?.urlData?.utm_id || this.navExtra?.urlData?.campaign_id){
            isUserAdmin(this.userService).then((bool) => {
              if(!bool) {
                this.userService.callTrackingAPI(data?.userDto?.userId,
                  {data: { 
                    page: this.navExtra?.urlData?.page,
                    utm_url: document.referrer + this.navExtra?.urlData?.page + '&' + 'utm_Id=' + this.navExtra?.urlData?.utm_id + '&' + 'utm_term=' + this.navExtra?.urlData?.utm_term+ '&' + 'utm_source=' + this.navExtra?.urlData?.utm_source+ '&' + 'utm_medium=' + this.navExtra?.urlData?.utm_medium+ '&' + 'utm_campaign=' + this.navExtra?.urlData?.utm_campaign+ '&' + 'utm_content=' +  this.navExtra?.urlData?.utm_content+ '&'  + 'utm_campaingn_id=' + this.navExtra?.urlData?.campaign_id,
                    utm_id: this.navExtra?.urlData?.utm_id || this.navExtra?.urlData?.campaign_id,
                    utm_term: this.navExtra?.urlData?.utm_term,
                    utm_source: this.navExtra?.urlData?.utm_source,
                    utm_medium: this.navExtra?.urlData?.utm_medium,
                    utm_campaign: this.navExtra?.urlData?.utm_medium,
                    utm_content: this.navExtra?.urlData?.utm_content,
                    grade: this.navExtra?.urlData?.grade,
                    liveclassId: this.navExtra?.urlData?.liveclassId,
                    exam: this.navExtra?.urlData?.exam,
                    action: this.navExtra?.urlData?.action
                  }}).subscribe(() => {});
              }
            })
            } else if(this.navExtra?.urlData?.page) {
              isUserAdmin(this.userService).then((bool) => {
                if(!bool) {
                  this.userService.callTrackingAPI(data?.userDto?.userId,{data: {...(this.navExtra?.urlData||{})}}).subscribe(() => {})
                }
              })
            }
            else {
              isUserAdmin(this.userService).then((bool) => {
                if(!bool) {
                  this.userService.callTrackingAPI(data?.userDto?.userId,{data: {...(this.navExtra?.urlData||{}), page}}).subscribe(() => {})
                }
              })
            }
        }
        this.userService.setUserRole(data?.userDto?.userId, page).subscribe(result => console.log(result));
        if(!(data?.userDto?.firstName && data?.userDto?.lastName && data?.userDto?.grade?.gradeId && data?.userDto?.exams?.length && (data?.userDto?.firstName?.trim() !== 'ildefaultfield') && (data?.userDto?.lastName?.trim() !== 'ildefaultfield')  )){
          this.router.navigateByUrl('/onboarding')
          return false
        }
       
        if (this.navExtra?.passwordReset) {
          this.router.navigate(['/reset-password'])
        } else if (this.navExtra?.register) {
          let ILITEData = this.navExtra
          console.log(ILITEData)
          this.gaService.webEngageEvent({
            'event': 'Sign up' ,
            'first_name': data.userDto.firstName,
            'last_name': data.userDto.lastName,
            'phone': data.userDto.phone,
            'grade': data?.userDto?.grade?.name?.replace('st', '')?.replace('nd', '')?.replace('rd', '')?.replace('th', ''),
            'whatsapp_consent': data?.userDto?.whatsappConsent
          })
          this.firebaseAnalyticsService.postEvent("user_signup_otp");
          if(this.isILITE || this.regLiveclass){ 
            this.ILITEReg(ILITEData);
          } else {
            this.router.navigate(['/target-exam'], { state: { urlData:this.navExtra?.urlData } })
          }
          let addressDetails = {
            firstName: data?.userDto?.firstName,
            lastName: data?.userDto?.lastName,
            phone: data?.userDto?.phone,
            addressLine1: "",
            addressLine2: "",
            cityName: "",
            email: "",
            isdCode: "+91",
            pinCode: 0,
            regionId: 0,
            active: true,
            addressType: '',
            countryId: 1,
            landMark: '',
            street: '',
          }
          this.userService.addUserAddress(addressDetails, data?.userDto?.userId).subscribe(res => console.log(res));
        } else {
          
          let _headers = {
            'accesstoken': data.accessToken,
            'studentid': localStorage.getItem('studentid'),
            // 'methodtype': 'RULES'
          };
          let userDetail = this.userService.getMobileAndName()
          let route = userDetail?.grade<3 ? '/dashboard/assessment': '/dashboard'
          let userType = this.userService.getUserType()
          if (userType == 2) {
            route += '/liveclass';
          } else {
            if (environment?.portal == 'teacher') {
              this.loginService.logoutEvent.emit({ showPopup: true, message: 'Oops!', message2: `Seems like you are not a registerd teacher.` });
              return;
            }
          }
          let ILITEData:any = this.navExtra
          this.gaService.webEngageEvent({
            'event': 'SignIn',
            'phone': this.userData.number ? this.userData.number : this.userData.phone,
            'page_url':window.location.href
          })        
          console.log(ILITEData)
          if(this.isILITE || this.regLiveclass){
            this.ILITEReg(ILITEData);            
          } else {
            this.classService.syncStudent();
            isUserAdmin(this.userService).then((bool) => {
              if(!bool) {this.userService.saveRewardHistory(2).subscribe(res => console.log(res), err => this.spinner.hide());};
            })
            this.router.navigateByUrl(route)
          }

          // setTimeout(()=>{
          //   this.AchievementsService.badgeInvokeSubject.next();
          // },1000);
        }
       
      } else if (data == false) {
        this.optErr = true
      }
    }, (error) => {
      this.optErr = true
    })
  }

  editNum() {
    this.router.navigate([`${this.navExtra?.register ? '/signup': 'signin'}`], { queryParams: this.queryParams  });
  }

  ILITEReg(ILITEData) {
    // this.targetExamService.fetchTargetExamList().subscribe((data: any) => {
    //   this.exams = data;
    //   let selectedExams = [];
    //     let index = this.exams.findIndex((ind) =>
    //       ind.name.replace(/[^a-z]/ig,'').toUpperCase() == ILITEData?.courses
    //     );
    //     if (index > -1) {
    //       console.log(index)
    //       selectedExams.push(this.exams[index]);
    //       this.startLearning({selectedExams, isILITE: true, grade: ILITEData?.gradeObj, ILITEData, urlData: ILITEData?.urlData})
    //     }      
    // });
    this.getTargetExamsList(ILITEData);
  }

  resendOtp() {
    this.signupService.generateOtp({ phone: Number(this.userData.number ? this.userData.number : this.userData.phone) }, this.userData.dialCode).subscribe((res) => {
      if (res) {
        this.resendOtpBtn = true;

        this.startCountdown(60)
      }
    })
  }
  getTargetExamsList(ILITEData) {
    let grade = {};
    this.targetExamService.fetchGradesList().subscribe(resp=>{
      grade = resp?.find(g=>g.name.toLowerCase() == ILITEData?.grade + 'th');
    });
    this.targetExamService.fetchTargetExamList().subscribe((data: any) => {
      this.exams = data;
      let selectedExams = [];
        let exam = ILITEData.isILITE ? ILITEData?.courses : ILITEData?.exam
        let index = this.exams.findIndex((ind) =>
          ind.name.replace(/[^a-z]/ig,'').toUpperCase() == exam
        );
        if (index > -1) {
          console.log(index)
          selectedExams.push(this.exams[index]);
          this.startLearning({selectedExams, isILITE: this.isILITE, regLiveClass:this.regLiveclass, grade: this.regLiveclass ? grade : ILITEData?.grade, ILITEData, urlData: ILITEData?.urlData})
        }      
    });
  }


}
